import { useEffect, useState } from 'react';
import { fetchPurchaseMotions } from '../utils/fetchPurchaseMotions';
export const usePurchaseMotions = ({
  location,
  apiName
}) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const [purchaseMotions, setPurchaseMotions] = useState([]);
  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setError(undefined);
    setPurchaseMotions([]);
    fetchPurchaseMotions({
      location,
      apiName
    }).then(motions => {
      if (!isMounted) return;
      setPurchaseMotions(motions);
    }).catch(e => {
      if (!isMounted) return;
      const errorObj = e instanceof Error ? e : new Error(String(e));
      setError(errorObj);
    }).finally(() => {
      if (!isMounted) return;
      setLoading(false);
    });
    return () => {
      isMounted = false;
    };
  }, [location, apiName]);
  return {
    loading,
    error,
    purchaseMotions
  };
};